import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { ActivatedRoute } from '@angular/router';
import { IGAEADLookupService } from './igaead-lookup.service';

@Injectable({
    providedIn: 'root'
})
export class ProposalsService {

    public headers;

    constructor(
        private http: HttpClient,
        private currentRoute: ActivatedRoute,
        private lookupService: IGAEADLookupService
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    }

    getProposals(session, body) {
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/proposals/${session}/${this.lookupService.getCommittee(body)}?env=${env}`, {headers: this.headers});
    }

    getDocsTakenNoteOfByBodyBySession(body, session){
        const env = EnvironmentLoader.environment.branch.toLowerCase();
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/getdocstakennoteof/${session}/${this.lookupService.getCommittee(body)}?env=${env}`, {headers: this.headers});
    }

}
